<template>
  <div
    ref="modalRef"
    class="flex sticky justify-center items-center w-screen h-screen inset-0"
    style="background: rgba(0, 0, 0, .5)">
      <slot />
  </div>
</template>

<script>
import { ref, onMounted, onUnmounted } from 'vue';

export default {
  setup() {
    const modalRef = ref(null);

    onMounted(() => {
      setTimeout(() => {
        modalRef.value.remove();
        document.body.append(modalRef.value);
        document.body.style.overflow = 'hidden';
      }, 0);
    });

    onUnmounted(() => {
      document.body.style.overflow = null;
    });

    return { modalRef };
  },
};
</script>
